import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import RuleTypeStore from './RuleTypeStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class RuleStore {

  @setter @observable id;
  @setter @observable type;
  @setter @toggle @observable active;
  @setter @toggle @observable displayInWidget;
  @setter @observable name;
  @setter @observable pointsDescriptor;
  @setter @observable additionalNotes;
  @setter @observable properties;

  // custom fields
  @setter @toggle @observable available;

  static create(data={}) {
    const instance = new RuleStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "type": new RuleTypeStore(),
      "active": false,
      "displayInWidget": false,
      "name": "",
      "pointsDescriptor": "",
      "additionalNotes": "",
      "properties": {},

      "available": true,
    };
  }

  constructor(defaults=RuleStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=RuleStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "type", "accessor": "type", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": RuleTypeStore},
      {"field": "name"},
      {"field": "active"},
      {"field": "displayInWidget", "accessor": "display_in_widget"},
      {"field": "pointsDescriptor", "accessor": "points_descriptor"},
      {"field": "additionalNotes", "accessor": "additional_notes"},
      {"field": "properties"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get isLinkPoints() {
    if (this.type.isSocial) return true;
    if (this.type.key === 'go_to_link') return true;
    return false;
  }

  @computed get btnText() {
    if (!this.isLinkPoints) return "";
    return this.properties.btn_text;
  }

  @computed get btnLink() {
    if (!this.isLinkPoints) return "";

    let encodedShareUrl = encodeURIComponent(this.properties.share_url);
    if (this.type.key === 'facebook_share') {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}`;
    }

    if (this.type.key === 'twitter_share') {
      return `https://twitter.com/share?url=${encodedShareUrl}&text=${this.properties.message}`;
    }

    if (this.type.key === 'go_to_link') {
      return this.properties.url;
    }

    if (this.properties.instagram_username) return `https://www.instagram.com/${this.properties.instagram_username}/`;
    if (this.properties.twitter_username) return `https://twitter.com/${this.properties.twitter_username}`;
    if (this.properties.tiktok_username) return `https://www.tiktok.com/@${this.properties.tiktok_username}`;
    if (this.properties.facebook_page_url) return this.properties.facebook_page_url;

    return "";
  }
}

export default RuleStore;



